export const LISTE_CAMPAGNE = {
  title: 'Liste des campagnes',
  actions: {
    filtre: 'Filtre',
    addCampagne: 'Nouvelle campagne',
    visible: 'Visible par le réseau',
    nonVisible: 'Non visible par le réseau',
  },
  tab: {
    libelle: 'Libellé',
    libelleInterne: 'Libellé interne',
    marque: 'Marque',
    tags: 'Tag(s)',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
    creatorUser: 'Ajoutée par',
    visibleParLaMarque: 'Visible par le réseau',
  },
  filtre: {
    libelle: 'Libellé',
    libelleInterne: 'Libellé interne',
    marque: 'Marque(s)',
    tag: 'Tag(s)',
    actif: 'Actif',
    newsLetter: 'Newsletter',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
  },
  archiverDesarchiver: {
    archive: 'Etes-vous sûr de vouloir archiver cette campagne ?',
    archiveSuccess: 'La campagne a été archivée avec succès.',
    archiveMultiple: 'Etes-vous sûr de vouloir archiver ces campagnes ?',
    archiveMultipleSuccess: 'Les campagnes ont été archivée avec succès.',
    desarchive: 'Etes-vous sûr de vouloir désarchiver cette campagne ?',
    desarchiveSuccess: 'La campagne a été désarchivée avec succès.',
    desarchiveMultiple: 'Etes-vous sûr de vouloir désarchiver ces campagnes ?',
    desarchiveMultipleSuccess: 'Les campagnes ont été désarchivée avec succès.',
    messages: {
      errorArchivage: 'Impossible d\'archiver cette campagne.',
      errorDesarchivage: 'Impossible de désarchiver cette campagne.',
    },
  },
  popupPrevention: {
    visible: 'Êtes-vous sûr de vouloir rendre ces campagnes visible par le réseau ?',
    nonVisible: 'Êtes-vous sûr de vouloir rendre ces campagnes non visible par le réseau ?',
  },
  messages: {
    successCampagneUpdateVisibilite: 'Campagnes modifiées avec succès',
  },
  delete: {
    confirmation: 'Etes-vous sûr de vouloir supprimer cette campagne ?',
    success: 'La campagne a été supprimée avec succès.',
  },
};

export const DETAIL_CAMPAGNE = {
  title: 'Détail campagne {libelle}',
  breadcrumbTitle: 'Détail campagne',
  archive: 'Archivé',
  informationsHeader: 'Informations générales',
  informations: {
    libelle: 'Libellé :',
    libelleInterne: 'Libellé interne :',
    marque: 'Marque :',
    tags: 'Tags :',
    tagArchive: 'Tag archivé',
    dateDebut: 'Date debut :',
    dateFin: 'Date Fin :',
    newsLetter: 'Newsletter :',
    visibleParLaMarque: 'Visible par le réseau :',
  },
  tab: {
    details: 'Détails',
    demandeImpression: 'Demandes d\'impressions',
  },
  libelleForLogo: 'Campagne {libelle}',
  campagneArchivee: 'Campagne archivée',
};

export const EDITION_CAMPAGNE = {
  titleCreation: 'Création campagne',
  titleModification: 'Modification campagne {libelle}',
  informationsHeader: 'Informations générales',
  informations: {
    libelle: 'Libellé',
    libelleInterne: 'Libellé interne',
    marque: 'Marque',
    tags: 'Tags',
    dateDebut: 'Date debut',
    dateFin: 'Date Fin',
    newsLetter: 'Newsletter',
    visibleParLaMarque: 'Visible par le réseau',
  },
  validation: {
    marque: 'Marque',
    libelleInterne: 'Libellé interne',
  },
  messages: {
    successCreation: 'La campagne a été  réalisée avec succès.',
    errorCreation: 'Enregistrement de la campagne impossible.',
    successModification: 'La campagne a été modifiée avec succès.',
    errorModification: 'Modification de la campagne impossible.',
    infoAjoutTagSucess: 'Tag ajouté avec succès.',
  },
  tagInfo: 'Si le tag n\'existe pas il sera créé en validant l\'entrée.',
};
